import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';

type Props = {
  onClose: () => void;
  onContinue: () => void;
};

const SelfScheduledApplicationStageAlert = ({ onClose, onContinue }: Props) => {
  const { t } = useTranslation('hiring-dashboard-schedule');

  return (
    <Dialog
      open
      dataTestId="schedule-object-self-scheduled-application-stage-alert"
      title={t('schedule.content.selfScheduleStageAlert')}
      onClose={onClose}
      cancelOptions={{
        dataTestId: 'schedule-object-self-scheduled-application-stage-alert-cancel-button',
        label: t('hiring-dashboard-common:common.cancel'),
        onClick: onClose,
      }}
      submitOptions={{
        dataTestId: 'schedule-object-self-scheduled-application-stage-alert-continue',
        label: t('hiring-dashboard-common:common.continue'),
        onClick: onContinue,
      }}
    >
      {t('schedule.content.selfScheduleStageAlertBody')}
    </Dialog>
  );
};

export default SelfScheduledApplicationStageAlert;
